<template>
  <v-card>

    <!-- actions -->
    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <!-- search -->
      <v-text-field
        v-model="$store.state.communication.field.keyword"
        placeholder="Rechercher par mot clé"
        label="Rechercher par mot clé"
        outlined
        hide-details
        dense
        class="user-search me-3 mb-4"
        @keyup="filterCommunications"
      >
      </v-text-field>

      <v-spacer></v-spacer>

    </v-card-text>

    <!-- table -->
    <v-data-table
      loading-text="Chargement..."
      no-data-text="Aucun résultat"
      no-results-text="Aucun résultat"
      :headers="headers"
      :items="$store.getters['communication/communications']"
      :items-per-page="$store.getters['communication/per_page']"
      :page.sync="$store.getters['communication/current_page']"
      dense
      fixed-header
      height="500"
      hide-default-footer
      :loading="loading"
      @page-count="currentPage = $event"
    >
      <!-- title -->
      <template #[`item.title`]="{item}">
        <div class="d-flex align-center">
          <v-avatar
            :color="item.highlight_image ? '' : 'primary'"
            :class="item.highlight_image ? '' : 'v-avatar-light-bg primary--text'"
            size="32"
          >
            <v-img
              v-if="item.highlight_image"
              :src="`${item.highlight_image}`"
            ></v-img>
            <span v-else-if="item.title">{{ item.title !== null && item.title !== undefined ? item.title.slice(0,2).toUpperCase() : null }}</span>
            <v-img
              v-else
              :src="require('@/assets/images/avatars/1.png')"
            />
          </v-avatar>
          <div class="d-flex flex-column ms-3">
            <span class="d-block font-weight-semibold text--primary text-truncate">{{ item.title }}</span>
          </div>
        </div>
      </template>
      <template #[`item.created_at`]="{item}">
        {{ formatingDate(`${item.created_at}`) }}
      </template>
      <template #[`item.updated_at`]="{item}">
        {{ formatingDate(`${item.updated_at}`) }}
      </template>
      <template #[`item.deleted_at`]="{item}">
        {{ item.deleted_at !== null ? formatingDate(`${item.deleted_at}`) : null }}
      </template>

      <template #[`item.with_push_notif`]="{item}">
        <v-chip
          small
          :color="item.with_push_notif === true ? 'success' : 'error'"
        >
          {{ item.with_push_notif === true ? "OUI" : "NON" }}
        </v-chip>
      </template>

      <!-- actions -->
      <template #[`item.actions`]="{item}">
        <v-tooltip
          right
          color="primary"
        >
          <template #activator="{ on, attrs }">
            <v-icon
              color="primary"
              small
              v-bind="attrs"
              @click="getCommunicationDetails(item.id)"
              v-on="on"
            >
              {{ icons.mdiEyeOutline }}
            </v-icon>
          </template>
          <span>Consulter</span>
        </v-tooltip>

      </template>
    </v-data-table>
    <v-card-text class="pt-2">
      <v-row>
        <v-col
          lg="2"
          cols="3"
        >
          <v-select
            v-model="$store.state.communication.field.paginate"
            :items="itemsPerPage"
            item-text="text"
            item-value="value"
            label="Lignes par page:"
            type="number"
            min="-1"
            max="15"
            hide-details
            @input="getEltsPerPage"
          ></v-select>
        </v-col>

        <v-col
          lg="10"
          cols="9"
          class="d-flex justify-end"
        >
          <v-pagination
            v-model="currentPage"
            total-visible="6"
            :length="lastPage"
            @input="getElts"
          ></v-pagination>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api'
import { customFormatDate } from '@core/utils/filter'
import {
  mdiAccountLock,
  mdiDeleteOutline,
  mdiDotsVertical, mdiEyeOutline, mdiLockOpen,
  mdiPencilOutline, mdiPlus,
  mdiSquareEditOutline,
} from '@mdi/js'
import store from '@/store'
import router from "@/router";
import {watch} from "@vue/composition-api/dist/vue-composition-api";

export default {
  name: 'UserCommunicationsList',

  props: {
    // eslint-disable-next-line vue/prop-name-casing
    user_id: {
      type: String,
      default: null,
    },
    isRefreshed: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const isLockedColor = {
      false: 'info',
      true: 'success',
    }
    const loading = ref(false)
    const currentPage = ref(null)
    const lastPage = ref(null)
    const dialogDelete = ref(false)
    const isDialogVisible = ref(false)
    const isDialogVisible2 = ref(false)
    const dialog = ref(false)

    const formattingDate = date => customFormatDate(date, {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    })

    const closeDialog = () => {
      dialog.value = false
    }

    const getElts = (page = 1) => {
      loading.value = true
      store.state.communication.field.user_id = props.user_id

      store.dispatch('communication/getCommunications', { page, field: store.state.communication.field }).then(() => {
        currentPage.value = store.getters['communication/current_page']
        lastPage.value = store.getters['communication/last_page']
        loading.value = false
      })
    }

    const filterElts = () => {
      setTimeout(() => {
        getElts()
      }, 1000)
    }

    // eslint-disable-next-line camelcase
    const getEltsPerPage = per_page => {
      // eslint-disable-next-line camelcase
      if (per_page !== null) {
        loading.value = true
        // eslint-disable-next-line camelcase
        store.state.communication.field.paginate = per_page
        store.state.communication.field.user_id = props.user_id
        store.dispatch('communication/getCommunications', {
          page: store.getters['communication/current_page'],
          field: store.state.communication.field,
        }).then(() => {
          currentPage.value = store.getters['communication/current_page']
          lastPage.value = store.getters['communication/last_page']
          loading.value = false
        })
      }
    }

    onMounted(() => {
      setTimeout(() => {
        getElts(store.getters['communication/current_page'])
      }, 500)
    })

    const filterCommunications = () => {
      setTimeout(() => {
        getElts(store.getters['communication/current_page'])
      }, 1000)
    }

    const getCommunicationDetails = id => {
      router.push({ name: 'communicationDetails', params: { id } })
    }

    const formatingDate = date => customFormatDate(date, {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    })

    watch(() => props.isRefreshed, newValue => {
      setTimeout(() => {
        getElts(store.getters['communication/current_page'])
      }, 1000)
    })

    return {
      formatingDate,
      getCommunicationDetails,
      filterCommunications,
      filterElts,
      formattingDate,
      closeDialog,
      loading,
      getEltsPerPage,
      getElts,
      currentPage,
      lastPage,
      dialog,
      dialogDelete,
      isDialogVisible,
      isDialogVisible2,
      headers: [
        { text: 'TITRE', value: 'title', sortable: false },
        { text: 'AVEC NOTIFICATION PUSH', value: 'with_push_notif', sortable: false },
        { text: 'DATE DE CREATION', value: 'created_at', sortable: false },
        { text: 'DATE DE MISE A JOUR', value: 'updated_at', sortable: false },
        { text: 'DATE DE SUPPRESSION', value: 'deleted_at', sortable: false },
        { text: 'ACTIONS', value: 'actions', sortable: false },
      ],
      itemsPerPage: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '15', value: 15 },
        { text: '20', value: 20 },
      ],
      status: {
        1: 'Current',
        2: 'Professional',
        3: 'Rejected',
        4: 'Resigned',
        5: 'Applied',
      },
      is_locked: {
        1: true,
        2: false,
      },
      isLockedColor,

      // icons
      icons: {
        mdiSquareEditOutline,
        mdiDotsVertical,
        mdiDeleteOutline,
        mdiPencilOutline,
        mdiAccountLock,
        mdiLockOpen,
        mdiPlus,
        mdiEyeOutline,
      },
    }
  },
}
</script>

<style scoped>
.v-data-table-header th {
  white-space: nowrap;
}
</style>
